"use strict";

(function($) {
    $(function() {

        $('.js-show-cta').click(function() {

            if($(this).parents('.form-group').find('.form-control').hasClass('inactive')) {
                $(this).parents('.form-group').find('.edit').hide();
                $(this).parents('.form-group').find('.cta').show();
                $(this).parents('.form-group').find('.form-control.inactive').removeClass('inactive');
                $(this).parents('.form-group').find('.phone-number.inactive').removeClass('inactive');

                var searchInput = $(this).parents('.form-group').find('.form-control');
                var strLength = searchInput.val().length * 2;
                searchInput.focus();
                searchInput[0].setSelectionRange(strLength, strLength);
            } else {
                $(this).parents('.form-group').find('.edit').show();
                $(this).parents('.form-group').find('.cta').hide();
                $(this).parents('.form-group').removeClass('has-error');
                $(this).parents('.form-group').find('.error-text').remove();
                $(this).parents('.form-group').find('.form-control').addClass('inactive');
                $(this).parents('.form-group').find('.phone-number').addClass('inactive');
            }

        });

    });
})(jQuery);
